/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Packaging_Pnk_Qty_Mode_No_Lot_TooltipInputs */

const vi_packaging_pnk_qty_mode_no_lot_tooltip = /** @type {(inputs: Packaging_Pnk_Qty_Mode_No_Lot_TooltipInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Vật tư theo số lượng không có lô cụ thể`)
};

/**

* @param {Packaging_Pnk_Qty_Mode_No_Lot_TooltipInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const packaging_pnk_qty_mode_no_lot_tooltip = /** @type {((inputs?: Packaging_Pnk_Qty_Mode_No_Lot_TooltipInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Packaging_Pnk_Qty_Mode_No_Lot_TooltipInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_packaging_pnk_qty_mode_no_lot_tooltip(inputs)
});